<template>
  <EmpowermentForm :empowerment="resource"
                   :all-rights="allRights"
                   @formSubmit="createFormSubmitted($event)" />
</template>

<script>
import EmpowermentForm from "./EmpowermentForm.vue";
import EmpowermentMixin from "./EmpowermentMixin";
import store from "./EmpowermentStore";
import companyStore from "../Company/CompanyStore";

const responseStore = {
  response: {
    resource: {
      teammate_ability_ids: []
    }
  },
  allRightsResponse: null
};

const fetchResource = async (to, from, next) => {
  responseStore.allRightsResponse = await store.fetchAllRights();

  next();
};

export default {
  name: "EmpowermentNew",

  title () {
    return this.$t("common.newModel", { model: this.$t("empowerment.model") }) + ` - ${companyStore.currentCompany.name} - ${Dashboard.currentTenant.name}`;
  },

  components: {
    EmpowermentForm
  },

  mixins: [EmpowermentMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data: function () {
    return {
      store: store,
      responseStore: this.$_.cloneDeep(responseStore)
    };
  },

  computed: {
    allRights () {
      return this.responseStore.allRightsResponse;
    }
  },

  mounted () {
    this.addBreadcrumb(this.$t("common.newModel", { model: this.$t("empowerment.model") }));
  }
};
</script>
